import { Component, Input } from '@angular/core';
import { MartOrderDetailsComponent } from 'app/mart';

@Component({
    selector: 'mart-order-details-chat-tab',
    templateUrl: './mart-order-details-chat-tab.component.html',
    styleUrls: [
        './mart-order-details-chat-tab.component.scss',
        '../mart-order-details.component.scss'
    ]
})
export class MartOrderDetailsChatTabComponent {
    @Input()
    public parent!: MartOrderDetailsComponent;
}
